import axios from "axios";

export default {
  computed: {
    HOST() {
      return this.$store.state.HOST;
    }
  },
  methods: {
    transportRequest(
      method,
      uri,
      data = {},
      sendBearer = true,
      cancelToken = null
    ) {
      const headers = { "X-Requested-With": "XMLHttpRequest" };
      if (sendBearer)
        headers.Authorization = `Bearer ${this.$store.state.TOKEN}`;
      this.messages = {};
      const url = uri.substr(0, 4) === "http" ? uri : this.HOST + uri;

      const axiosProps = {
        method: method,
        url: url,
        headers: headers,
        data: data
      };

      if (method.toLowerCase() === "get") {
        axiosProps.params = data;
      }
      if (cancelToken !== null) {
        axiosProps.cancelToken = cancelToken;
      }

      return axios(axiosProps);
    }
  }
};
